'use client';

import {
    Box,
    Flex,
    HStack,
    Separator,
    Text,
    VStack,
} from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import {
    Degree360Icon,
    RightIcon,
} from '@/_assets/icon-components';
import { useCustomLocale } from '@/_hooks/useCustomLocale';
import { formatPhoneNumber } from '@/_utils/formatPhoneNumber';
import { IBranch } from '@/_types';
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function About({ data }: { data: IBranch }) {
    const t = useTranslations();  
    const [virtualTourUrl, setVirtualTourUrl] = useState('');
    const currentLocale = useCustomLocale();

    useEffect(() => {
        if (data?.virtual_tour) {
          axios
            .get(data.virtual_tour)
            ?.then(() => setVirtualTourUrl(data.virtual_tour))
            .catch(() => { });
        }
      }, [data?.virtual_tour]);
    

    return (
        <div>          <Box mb={8} pb={20}>
            <HStack justifyContent={'space-between'}>
                <Flex alignItems='center' gap={2}>
                    <Text as='h1' fontWeight={700} fontSize={22} lineHeight={1.2}>
                        {data?.address}
                    </Text>
                    <Link
                        href={`https://yandex.com/maps/?ll=${data?.location?.long}%2C${data?.location?.lat}&mode=whatshere&whatshere%5Bpoint%5D=${data?.location?.long}%2C${data?.location?.lat}&z=14`}
                        target='_blank'
                        rel='noreferrer'
                        aria-label={data?.address}
                    >
                        <RightIcon width='16' height='16' />
                    </Link>
                </Flex>
            </HStack>
            <Text mt={2} color='gray.800' fontSize={14} maxW='655px'>
                {data?.description?.[currentLocale]}
            </Text>

            <Flex mt={4} flexDirection='column' gap={2}>
                <HStack align='baseline'>
                    <Text color='gray.800'>{t('branch_schedule')}:</Text>
                    <Text>
                        {data?.open_time} ~ {data?.close_time}
                    </Text>
                </HStack>
                <HStack align='baseline'>
                    <Text color='gray.800'>{t('delivery_schedule')}:</Text>
                    <Text>
                        {data?.work_hour_start} ~ {data?.work_hour_end}{' '}
                        {!data?.is_work && `(${t('not_working_now')})`}
                    </Text>
                </HStack>

                <Flex gap={2}>
                    <Text color='gray.800'>
                        {t('phone_number')}:
                    </Text>
                    <VStack alignItems='start' gap={1}>
                        {data?.phones.map((el: string) => (
                            <Link key={el} href={`tel:${el}`}>
                                {formatPhoneNumber(el)}
                            </Link>
                        ))}
                    </VStack>
                </Flex>

                <Separator borderColor='#00000012' my={4} />

                {data?.destination && (
                    <Flex gap={1}>
                        <Text color='gray.800'>
                            {t('destination_branch')}:
                        </Text>
                        <Text>{data?.destination}</Text>
                    </Flex>
                )}
                <Flex gap={1}>
                    <Text color='gray.800'>
                        {t('parking')}:
                    </Text>
                    <Text>{data?.has_parking ? t('there_is') : t('no')}</Text>
                </Flex>
                {Boolean(data?.seats_count && data?.seats_count > 0) && (
                    <Flex gap={{ base: 1, md: 2 }}>
                        <Text color='gray.800'>
                            {t('seat_count')}:
                        </Text>
                        <Text>{data?.seats_count}</Text>
                    </Flex>
                )}
            </Flex>

            <Separator borderColor='#00000012' my={4} />

            <Flex flexDirection='column' gap={2} mt={4}>
                {virtualTourUrl && (
                    <Flex
                        alignItems='center'
                        gap={4}
                        _hover={{ textDecor: 'underline' }}
                    >
                        <Link href={virtualTourUrl}>
                            <Degree360Icon color='currentColor' />
                        </Link>
                        <Text>{t('virtual_tour')}</Text>
                    </Flex>
                )}
            </Flex>
        </Box>
        </div>
    )
}
